import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";

const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

export const ChangeSectionApi = {
    changeStudentSection: async (data) => {
    const axiosConfig = createAxiosConfig(
      "change_student_section",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
}